import directives from './module';
import {RescaleSvc} from 'services/RescaleSvc';
import {AnimatronPreviews} from '../services/AnimatronPreviewsSvc';
import {Utils} from 'underscore-extensions';

interface Scope extends ng.IScope {
    project?: anm.Project;
    $ctrl?: {project?: anm.Project};
}

directives.directive('pickPreviewImage',
    (AnimatronPreviews: AnimatronPreviews) =>
        (scope: Scope,
         element: ng.IAugmentedJQuery,
         attrs: {pickPreviewImage: string}) => {
            const project: anm.Project = scope.project || (scope.$ctrl && scope.$ctrl.project);

            const opts = scope.$eval(attrs.pickPreviewImage) || {};
            const width = opts.width || 720;

            if (opts.rescale) {
                Utils.rAF(() => {
                    const w = element[0].getBoundingClientRect().width - 20;
                    const dim = RescaleSvc.resizeWithAspectRatio(
                        project.width * 9999,
                        project.height * 9999,
                        w,
                        opts.rescale.height);
                    element[0].style.width = dim.width + 'px';
                    element[0].style.height = dim.height + 'px';
                });
            }

            const preview = AnimatronPreviews
                .pickPreview(opts.images || project.preview_metadata, width)
                .replace(/(http:|https:)/, '');

            const image = document.createElement('img');

            image.classList.add('preview');
            image.src = preview;
            if (project) {
                image.style.color = 'transparent';
                image.alt = project.name;
            }
            element[0].appendChild(image);

            image.onerror = () => {
                element.addClass('animatron-hero-background');
                image.style.display = 'none';
            };
            // image.onload  = () => element[0].appendChild(image);
        }
);





// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/pickPreviewImageDirective.ts